import React from "react";
import { SplitContainer } from "../../../containers";

const SplitContainers = (props) => {
  return <SplitContainer {...props} />;
};

export default SplitContainers;
